import React, { Suspense, useState, useEffect } from 'react';
import { renderRoutes } from 'react-router-config';
import { makeStyles } from '@material-ui/core/styles';
import { 
  Hidden, 
  SwipeableDrawer, 
  Grid, 
  Popover, 
  Drawer, 
  MenuItem, 
  Menu, 
  IconButton, 
  Typography, 
  Badge, 
  CssBaseline, 
  Tooltip, 
  Toolbar, 
  AppBar, 
  CircularProgress, 
  useMediaQuery, 
  useTheme, 
  Box
} from '@material-ui/core';
import { Link, useLocation } from "react-router-dom";
import clsx from 'clsx';
import ListMenu from '../components/list-menu.js';
import logo from '../assets/logo.png';
import Alert from '@material-ui/lab/Alert';
import { DropzoneArea } from 'material-ui-dropzone';
import { 
  AccountCircle, 
  Notifications, 
  ExitToAppOutlined, 
  HelpOutlineOutlined, 
  FormatAlignLeftOutlined, 
  PhotoCameraOutlined, 
  CloseOutlined, 
  SettingsOutlined, 
  Close,
  MenuRounded
} from '@material-ui/icons';
import { Spacer, Button } from '../components/atoms';
import { useAuthContext } from '../context/Auth.js';
import colors from '../components/colors.js';

const drawerWidth = 240;
const drawerWidthSmall = 100;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  progress: {
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%'
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: colors?.primary
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    transition: '0.2s',
    transitionTimingFunction: 'ease-out'
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerSmall: {
    width: drawerWidthSmall,
    flexShrink: 0,
    transition: '0.2s',
    transitionTimingFunction: 'ease-out'
  },
  drawerPaperSmall: {
    width: drawerWidthSmall,
  },
  drawerContainer: {
    overflow: 'auto',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  testeCss: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  imageMenu: {
    width: '40%'
  },
  imageMenuSmall: {
    width: '60%'
  }
}));

const LayoutDashboard = props => {

  const location = useLocation();
  const { route } = props;
  const classes = useStyles();
  const [anchorElT, setAnchorElT] = useState(null);
  const openT = Boolean(anchorElT);
  const [open, setOpen] = useState(true);
  const [anchorEl, setAnchorEl] = useState(false);
  const openPopover = Boolean(anchorEl);
  const id = openPopover ? 'simple-popover' : undefined;
  const [page, setPage] = useState();
  const [sizeMenu, setSizeMenu] = useState('full');
  const [openModalPicture, setOpenModalPicture] = useState(false);
  const [picture, setPicture] = useState();
  const [loadPicture, setLoadPicture] = useState(false);
  const { userInfos, userProfile } = useAuthContext();
  const [openMenuMobile, setOpenMenuMobile] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleMenu = (event) => {
    setAnchorElT(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorElT(null);
  };

  const handleExit = () => {
    localStorage.clear();
    if(window.location.hostname === "localhost"){
      window.location.href = "http://localhost:3000/entrar";
    }else{
      window.location.href = "https://gryb.appandwebstudio.com.br/entrar";
    }
  }

  useEffect(() => {
    setPage(location.pathname.split('/')[1]);
  }, [location.pathname]);

  const handleClickPopover = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  const handleChangeSizeMenu = () => {

    if(sizeMenu === "full" || sizeMenu === null){
      setSizeMenu('small');
    }else{
      setSizeMenu('full');
    }

  }

  return (
    <div className={classes.root}>

      <Suspense fallback={
        <div className={classes.progress}>
          <CircularProgress style={{ color: colors?.primary }} />
        </div>
      }>

        <CssBaseline />
        <AppBar position="fixed" className={classes.appBar}>
          <Toolbar>

            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px'
              }}
            >
              {isMobile ?
                <MenuRounded 
                  onClick={() => {
                    setOpenMenuMobile(true);
                  }} 
                />
              :
                <Tooltip 
                  title={
                    !sizeMenu || sizeMenu === "full" ? 'Diminuir tamanho do menu' : 'Aumentar tamanho do menu'
                  }
                >
                  <MenuRounded 
                    style={{cursor: 'pointer'}} 
                    onClick={() => {
                      handleChangeSizeMenu();
                    }} 
                  />
                </Tooltip>
              }
              <Typography variant="body2" style={{ paddingTop: '2px' }}>{userInfos?.name} {(!isMobile && userInfos?.email) && `(${userInfos?.email})`} {userProfile?.descricao && ` - ${userProfile?.descricao}`}</Typography>
            </div>

            <Typography variant="h6" noWrap style={{flexGrow: '1', display: 'flex', alignItems: 'center'}}></Typography>

            <div>

              {/* <Badge onClick={handleClickPopover} badgeContent={4} color="error" style={{cursor: 'pointer', marginRight: '15px'}}>
                <Notifications onClick={handleClickPopover} style={{cursor: 'pointer'}} />
              </Badge> */}

              {/* <Link to="help">
                <IconButton>
                  <HelpOutlineOutlined style={{color: '#FFF'}} />
                </IconButton>
              </Link> */}

              <Popover
                id={id}
                open={openPopover}
                anchorEl={anchorEl}
                onClose={(handleClosePopover)}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
              >
                <div style={{width: '400px', padding: '15px'}}>

                  <Grid container style={{marginBottom: '15px'}}>
                    <Grid md={12}>
                      <div style={{display: 'flex', alignItems: 'center', width: '100%'}}>
                        <Typography variant="body1" style={{color: '#707072', float: 'left', width: '100%'}}>Avisos</Typography>
                        <CloseOutlined onClick={(handleClosePopover)} style={{color: '#707072', cursor: 'pointer', float: 'right'}} />
                      </div>
                    </Grid>
                  </Grid>

                  <Grid container style={{marginBottom: '10px'}}>
                    <Grid md={12}>
                      <Alert variant="filled" severity="error">
                        Fluxo de caixa ficou negativo
                      </Alert>
                    </Grid>
                  </Grid>
                  <Grid container style={{marginBottom: '10px'}}>
                    <Grid md={12}>
                      <Alert variant="filled" severity="warning">
                        Seus impostos estão vencendo
                      </Alert>
                    </Grid>
                  </Grid>
                  <Grid container style={{marginBottom: '10px'}}>
                    <Grid md={12}>
                      <Alert variant="filled" severity="info">
                        Termine de configurar sua conta
                      </Alert>
                    </Grid>
                  </Grid>
                  <Grid container style={{marginBottom: '10px'}}>
                    <Grid md={12}>
                      <Alert variant="filled" severity="success">
                        Novas receitas
                      </Alert>
                    </Grid>
                  </Grid>

                </div>
              </Popover>

              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                }}
              >
                {/* {userInfos?.nome} */}
                <Typography style={{ cursor: 'pointer' }} onClick={handleExit}>Sair</Typography>
              </div>

              {/* <IconButton
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleMenu}
                color="inherit"
              >
                <AccountCircle />
              </IconButton> */}
              <Menu
                id="menu-appbar"
                anchorEl={anchorElT}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                open={openT}
                onClose={handleClose}
                onClick={handleClose}
              >
                {/* <MenuItem onClick={() => {setOpenModalPicture(true)}} style={{color: '#707072'}}>
                  <PhotoCameraOutlined /> &nbsp; Imagem de perfil
                </MenuItem> */}
                <Link to="meus-dados" style={{textDecoration: 'none', color: '#707072'}}>
                  <MenuItem>
                    <SettingsOutlined /> &nbsp; Minha conta
                  </MenuItem>
                </Link>
                <MenuItem style={{color: '#707072'}} onClick={handleExit}>
                  <ExitToAppOutlined /> &nbsp; Sair
                </MenuItem>
              </Menu>
            </div>
          </Toolbar>
        </AppBar>

        <Hidden mdUp>
          <SwipeableDrawer
            anchor='left'
            open={openMenuMobile}
            onClose={() => {setOpenMenuMobile(false)}}
          >
            <div style={{
              width: '70vw',
              padding: '10px'
            }}>
              <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingLeft: '18px', marginTop: '10px' }}>
                <Typography color="textSecondary">Menu</Typography>
                <IconButton size="small" onClick={() => {setOpenMenuMobile(false)}}>
                  <Close  />
                </IconButton>
              </Box>
              <ListMenu 
                sizeMenu={sizeMenu} 
                handleOnClick={() => {
                  setOpenMenuMobile(false);
                }}
              />
              <center>
                <img src={logo} style={{ width: '30%' }} />
              </center>
            </div>
          </SwipeableDrawer>
        </Hidden>

        <Hidden smDown>
          <Drawer
            className={!sizeMenu || sizeMenu === "full" ? classes.drawer : classes.drawerSmall}
            variant="permanent"
            classes={{
              paper: !sizeMenu || sizeMenu === "full" ? classes.drawerPaper : classes.drawerPaperSmall
            }}
          >
            <Toolbar />
            <div className={classes.drawerContainer}>
              <ListMenu 
                handleOnClick={() => {}}
                sizeMenu={sizeMenu} 
              />
              <center>
                <img src={logo} className={!sizeMenu || sizeMenu === "full" ? classes.imageMenu : classes.imageMenuSmall} />
              </center>
            </div>
          </Drawer>
        </Hidden>

        <main
          className={clsx(classes.content, {
            [classes.contentShift]: open,
          })}
        >
          <Toolbar />
          {renderRoutes(route.routes)}
        </main>

      </Suspense>

      <SwipeableDrawer
        anchor='left'
        open={openModalPicture}
        onClose={() => {setOpenModalPicture(false); setPicture('');}}
        onOpen={() => {setOpenModalPicture(true)}}
      >
        <div style={{
          width: '50vw',
          padding: '20px'
        }}>

          <CloseOutlined onClick={() => {setOpenModalPicture(false); setPicture('');}} style={{color: '#707072', cursor: 'pointer', float: 'right'}} />
          <Spacer direction="vertical" size={10} />
          <Grid spacing={3} container>
            <Grid item md={12} xs={12}>
              <Typography variant="h6">Altere a sua foto de perfil</Typography>
            </Grid>
            <Grid item md={12} xs={12}>
              <DropzoneArea
                onChange={(files) => setPicture(files[0])}
                showPreviewsInDropzone={false}
                showPreviews={true}
                filesLimit={1}
                dropzoneText="Selecione ou arraste a imagem"
                previewText="Imagem"
                acceptedFiles={['.jpeg', '.jpg', '.png']}
                dropzoneClass={classes.testeCss}
              />
            </Grid>
            <Grid item md={12} xs={12}>
              <Button 
                disabled={picture ? false : true}
                // onClick={updatePicture} 
                color="blue"
                variant="contained"
                label={loadPicture ? <CircularProgress size={20} style={{color: '#FFFFFF'}} /> : "Atualizar"}
              />
            </Grid>
          </Grid>

        </div>
      </SwipeableDrawer>
      
    </div>
  );
}

export default LayoutDashboard;